import { Toaster } from 'react-hot-toast';
import React from 'react';

const toasterOptions = {
  style: {
    fontWeight: 500,
    fontFamily: "'Montserrat', sans-serif",
    maxWidth: '500px',
  },
  duration: 3000,
};

const ToasterProvider = () => {
  return <Toaster toastOptions={toasterOptions} />;
};

export default ToasterProvider;
